import {
  Bell,
  Wrench,
  FileOutput,
  Settings,
  Lock,
  Users,
  UserCheck,
  BarChart3,
  CheckSquare,
  Building,
  DollarSign,
  CalendarDays,
  FileText,
  BookOpen,
  CreditCard,
  Shield,
  Activity
} from "lucide-react";
import { LucideIcon } from "lucide-react";


export type NavItem = {
  icon: LucideIcon;
  label: string;
  href: string;
};

export const mainNavItems: NavItem[] = [
  { icon: BarChart3, label: "Dashboard", href: "/dashboard" },
  { icon: BarChart3, label: "Consultants", href: "/consultants" },
  { icon: Users, label: "Client List", href: "/clients" },
  { icon: Building, label: "Company", href: "/company" },
  { icon: DollarSign, label: "Valuations", href: "/valuations" },
  { icon: BarChart3, label: "Benchmarks", href: "/benchmarks" },
  { icon: Users, label: "Team", href: "/team" },
  { icon: UserCheck, label: "Successors", href: "/successors" },
  { icon: CalendarDays, label: "Plan", href: "/plan" },
  { icon: CheckSquare, label: "Tasks", href: "/tasks" },
  { icon: FileText, label: "Documents", href: "/documents" },
  { icon: BookOpen, label: "Learn", href: "/learn" },
  { icon: FileText, label: "Report Center", href: "/reports" },
  { icon: Settings, label: "Settings", href: "/settings" },
];

export const settingsNavItems: NavItem[] = [
  { icon: Settings, label: "General", href: "appearance" },
  { icon: Bell, label: "Notifications", href: "notifications" },
  { icon: Lock, label: "Security", href: "security" },
  { icon: CreditCard, label: "Subscription", href: "billing" },
  { icon: FileOutput, label: "Data", href: "export" },
  { icon: Building, label: "Account", href: "company-information" },
];

export const platformAdminNavItems = [
  {
    href: '/admin',
    label: 'Platform Admin',
    icon: Shield,
    description: 'Platform administration dashboard'
  },
  {
    href: '/admin/audit',
    label: 'Audit Logs',
    icon: Activity,
    description: 'Platform admin audit trail'
  }
];
